export default __webpack_public_path__ + "static/media/main3.c8bdb2f3.jpg";